import { render, staticRenderFns } from "./GeneralDiscountFormTab.vue?vue&type=template&id=e2509146&scoped=true"
import script from "./GeneralDiscountFormTab.vue?vue&type=script&lang=js"
export * from "./GeneralDiscountFormTab.vue?vue&type=script&lang=js"
import style0 from "./GeneralDiscountFormTab.vue?vue&type=style&index=0&id=e2509146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2509146",
  null
  
)

export default component.exports